import React from 'react';
import { useSelector } from 'react-redux';
import { Popover } from '@milanote/roma';
import LabelsSearchBar from '../components/LabelsSearchBar';
import LabelLists from '../components/LabelLists';
import useLabelsTool from '../hooks/useLabelsTool';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import { getPlatformDetailsSelector } from '../../../../../../platform/platformSelector';
import { isPlatformTablet } from '../../../../../../platform/utils/platformDetailsUtils';

const LabelsToolbarPopupContent: React.FC<LabelsToolbarPopupProps> = (props) => {
    const platformDetails = useSelector(getPlatformDetailsSelector);
    const shouldAutoFocusSearch = !isPlatformTablet(platformDetails);
    const {
        allLabels,
        elements,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    } = useLabelsTool({ currentUserId: props.currentUserId });

    return (
        <>
            <LabelsSearchBar
                value={searchString}
                onChange={setSearchString}
                handleSearchSubmit={handleSearchSubmit}
                autoFocus={shouldAutoFocusSearch}
            />
            <Popover.Body className="max-h-[38rem] pb-1.5">
                <LabelLists
                    handleToggleLabelSelection={handleToggleLabelSelection}
                    handleCreateLabel={handleCreateLabel}
                    elements={elements}
                    searchString={searchString}
                    allLabels={allLabels}
                />
            </Popover.Body>
        </>
    );
};

export default LabelsToolbarPopupContent;
